define("social-listening/routes", ["exports", "ember-engines/routes"], function (_exports, _routes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/routes"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _routes.default)(function () {
    this.route('topics', function () {
      this.route('create');
      this.route('edit', {
        path: '/:listener_id/edit'
      });
      this.route('listener', {
        path: '/:listener_id'
      }, function () {
        this.route('media', {
          path: 'media/:media_id'
        });
      });
    });
    this.route('brands', function () {
      this.route('profile', {
        path: '/:social_profile_id'
      }, function () {
        this.route('mentions', function () {
          this.route('media', {
            path: 'media/:media_id'
          });
        });
        this.route('health', function () {
          this.route('media', {
            path: 'media/:media_id'
          });
        });
      });
      this.route('empty');
    });
    this.route('competitors', function () {
      this.route('create');
      this.route('competitor-group', {
        path: '/:competitor_group_id'
      });
      this.route('edit', {
        path: '/:competitor_group_id/edit'
      });
      this.route('empty');
    });
    this.route('brand-dna', function () {
      this.route('report', {
        path: '/'
      }, function () {
        this.route('edit', {
          path: '/:brand_dna_report_id/edit'
        });
        this.route('overview', {
          path: '/:brand_dna_report_id'
        });
      });
      this.route('create');
    });
    this.route('future-insights', function () {
      this.route('edit');
      this.route('overview', {
        path: '/'
      });
    });
  });
});